import { toWSDateString } from "@wingspanhq/fe-component-library";
import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

/**
 * Display name for an import batch: the name the user gave it, then the
 * spreadsheet it was filled from, then the day it was created.
 *
 * A batch created before `Batch.name` existed reads its name from the legacy
 * `bulkBatchName` label server-side, so this needs no fallback of its own.
 */
export const selectorImportBatchName = (batch: Batch): string => {
  const date = batch.events?.createdAt
    ? toWSDateString(batch.events.createdAt, "monthDayYear")
    : "";

  return (
    batch.name ||
    batch.metadata?.[BATCH_LABELS_WS_KEYS.bulkImporterFilename] ||
    date ||
    "--"
  );
};
